import { useRecoilValue } from 'recoil';
import { useQuery } from 'react-query';
import { currentDatabaseSelector, selectedLockYearState } from '@transport-insights/uikit';
import useRegulatoryReportingApi from '../api/useRegulatoryReportingApi';

export function useReports(name) {
  const rca = useRecoilValue(currentDatabaseSelector);
  const lockYear = useRecoilValue(selectedLockYearState);
  const api = useRegulatoryReportingApi();
  return useQuery(
    ['regulatory-reports', name, rca?.id, lockYear],
    async () => api.getReportData(name, rca?.id, lockYear),
    {
      enabled: rca?.id !== undefined && lockYear !== null,
    },
  );
}
